import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasArea, type Area } from '../lib/access';

/** Gate an admin route to roles that hold the given area in the access catalog. */
export function RequireArea({ area, children }: { area: Area; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!hasArea(user?.role, area)) return <Navigate to="/admin" replace />;
  return <>{children}</>;
}
